/**
 * Created by Daniela on 26/09/2016.
 */
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { ContaContabilListComponent } from "./conta-contabil-list/conta-contabil-list.component";
import { ContaContabilFormComponent } from "./conta-contabil-form/conta-contabil-form.component";
import { newRoute, editRoute } from "../../shared/services/data.service";

@NgModule({
    imports: [
        RouterModule.forChild([])
    ],
    exports: [
        RouterModule
    ]
})
export class ContaContabilRoutingModule {}

export const contaContabilRoutes: any[] = [
    {
        path: '',
        component: ContaContabilListComponent
    },
    {
        path: newRoute,
        component: ContaContabilFormComponent
    },
    {
        path: editRoute + '/:id',
        component: ContaContabilFormComponent
    }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil.routing.ts
 **/